(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  let currentFilter = 'all';
  let returnFocus;
  let previousHash = '';
  let activeStory = '';
  function filterArticles() {
    const query = normalize(document.querySelector('[data-article-search]')?.value || '');
    let count = 0;
    document.querySelectorAll('[data-article-card]').forEach(card => {
      const visible = (currentFilter === 'all' || card.dataset.category === currentFilter) && normalize(card.dataset.search).includes(query);
      card.hidden = !visible;
      if (visible) count++;
    });
    document.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === currentFilter)));
    const empty = document.querySelector('[data-no-results]');
    if (empty) empty.hidden = count > 0;
    const status = document.querySelector('[data-results-count]');
    if (status) status.textContent = `${count} article${count === 1 ? '' : 's'} disponible${count === 1 ? '' : 's'}`;
  }
  function openStory(id, source, changeHash = true) {
    const story = document.getElementById(id);
    const reader = document.querySelector('.vs-reader');
    const content = story?.querySelector('.vs-story-content');
    if (!content || !reader || !reader.showModal) return false;
    returnFocus = source || document.activeElement;
    if (!reader.open) previousHash = location.hash.startsWith('#article-') ? '#journal' : location.hash;
    activeStory = '#' + id;
    reader.querySelector('.vs-reader-body').replaceChildren(content.cloneNode(true));
    const title = reader.querySelector('h2');
    if (title) { title.id = 'vs-reader-title'; reader.setAttribute('aria-labelledby', title.id); }
    if (!reader.open) reader.showModal();
    reader.scrollTop = 0;
    if (changeHash) history.pushState(null, '', '#' + id);
    return true;
  }
  function bindReader() {
    const reader = document.querySelector('.vs-reader');
    if (!reader || reader.dataset.bound) return;
    reader.dataset.bound = 'true';
    reader.querySelector('.vs-reader-close').addEventListener('click', () => reader.close());
    reader.addEventListener('click', e => { if (e.target === reader) { const r = reader.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) reader.close(); } });
    reader.addEventListener('close', () => {
      if (location.hash === activeStory) history.replaceState(null, '', location.pathname + location.search + previousHash);
      returnFocus?.focus({preventScroll:true});
    });
  }
  function init() {
    document.documentElement.classList.add('vs-ready');
    bindReader();
    filterArticles();
    if (location.hash) openStory(decodeURIComponent(location.hash.slice(1)), null, false);
  }
  document.addEventListener('click', e => {
    const menu = e.target.closest('.vs-menu-toggle');
    if (menu) { const expanded = menu.getAttribute('aria-expanded') !== 'true'; menu.setAttribute('aria-expanded', String(expanded)); menu.setAttribute('aria-label', expanded ? 'Fermer le menu' : 'Ouvrir le menu'); document.getElementById('vs-mobile-nav').hidden = !expanded; }
    if (e.target.closest('#vs-mobile-nav a')) { const toggle = document.querySelector('.vs-menu-toggle'); toggle.setAttribute('aria-expanded', 'false'); toggle.setAttribute('aria-label', 'Ouvrir le menu'); document.getElementById('vs-mobile-nav').hidden = true; }
    const filter = e.target.closest('[data-filter]');
    if (filter) { currentFilter = filter.dataset.filter; filterArticles(); }
    const topic = e.target.closest('[data-topic]');
    if (topic) { currentFilter = topic.dataset.topic; const input = document.querySelector('[data-article-search]'); if (input) input.value = ''; filterArticles(); }
    if (e.target.closest('[data-reset-search]')) { currentFilter = 'all'; document.querySelector('[data-article-search]').value = ''; filterArticles(); }
    const search = e.target.closest('.vs-search-toggle');
    if (search && document.querySelector('[data-article-search]')) { e.preventDefault(); document.querySelector('#journal').scrollIntoView(); document.querySelector('[data-article-search]').focus({preventScroll:true}); }
    const link = e.target.closest('[data-story-link]');
    if (link) { const url = new URL(link.href, location.href); if (url.pathname === location.pathname && openStory(decodeURIComponent(url.hash.slice(1)), link)) e.preventDefault(); }
  });
  document.addEventListener('input', e => { if (e.target.matches('[data-article-search]')) filterArticles(); });
  window.addEventListener('popstate', () => { if (!openStory(decodeURIComponent(location.hash.slice(1)), null, false)) document.querySelector('.vs-reader[open]')?.close(); });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
